  <!-- #region HTML -->
<template>
  <div class="app">
    <!-- #region Alert Component -->
    <alert :SystemErrorAlert="isSystemError" @update:SystemErrorAlert="isSystemError = $event"></alert>
    <!-- #endregion -->

    <!-- #region Main Container -->
    <div class="main-container form-container">
      <!-- #region Steps Section -->
      <div class="steps">
        <div class="right-box">
          <div class="sub-container">
            <div class="title">
              <label>メールアドレス変更</label>
            </div>
            <div class="step-box text-left">
              <label class="step-title sp-hide">ステップ 1/2</label>
              <label class="step-description sp-hide">変更のメールアドレスを入力してください。</label>
            </div>
          </div>
          <div class="step-description-box text-left">
            <label class="step-title">ステップ 1/2</label>
            <div class="step-description">変更のメールアドレスを入力してください。</div>
          </div>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region Form -->
      <form novalidate @submit.prevent="validateUser">
        <md-card class="form-container">
          <!-- #region Form Content -->
          <div class="md-form">
            <hr>
            <div class="text-left display-fixed-element">
              <span class="fixed-variables-title">メールアドレスID：</span>
              <span class="fixed-variables-element">{{ form.oldEmail }}</span>
              <input type="hidden" v-model="form.oldEmail" name="mailaddress" />
            </div>

            <md-field :class="getValidationClass('newEmail')">
              <md-input id="new-email" v-model="form.newEmail" name="new-email" placeholder="新しいメールアドレスID" type="email"
                :disabled="sending" @input="resetAliasExists" />
              <span v-if="!$v.form.newEmail.required" class="md-error error">入力してください。</span>
              <span v-else-if="!$v.form.newEmail.email" class="md-error error">入力されたメールアドレスに誤りはございませんか？</span>
              <span v-else-if="!$v.form.newEmail.sameAs" class="md-error error">
                変更前と変更後のメールアドレスは、異なるものを入力してください。
              </span>
              <span v-else-if="isAliasExists === true" class="md-error error alias-error">
                このメールアドレスは既に使用されています。他のメールアドレスをご入力ください。
              </span>
            </md-field>
          </div>
          <!-- #endregion -->

          <!-- #region Progress Bar -->
          <md-progress-bar v-if="sending" md-mode="indeterminate" />
          <!-- #endregion -->

          <!-- #region Submit Container -->
          <div class="submit-container">
            <md-card-actions>
              <md-button type="submit" class="primary-button" :disabled="sending">認証コードをメールで受け取る</md-button>
            </md-card-actions>
            <md-card-content>
              <label>認証コードを通知するメールが、入力された新しいメールアドレスに送信されます。</label>
            </md-card-content>
          </div>
          <!-- #endregion -->
        </md-card>
      </form>
      <!-- #endregion -->
    </div>
    <!-- #endregion -->
  </div>
</template>
<!-- #endregion -->
<!-- #region JavaScript -->
<script>
// @ is an alias to /src
import Alert from '@/layout/Alerts.vue';
import { Auth } from 'aws-amplify';
import { validationMixin } from 'vuelidate';
import { email, not, required, sameAs } from 'vuelidate/lib/validators';

// const allemail = (email) => {
//   var re = /^(.+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//       return re.test(email);
// }

let cognito_user
let cognito_username

export default {
  name: 'ChangeEmail',
  mixins: [validationMixin],
  components: {
    "alert": Alert
  },
  props: {
    username: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    form: {
      oldEmail: null,
      newEmail: null,
      username: '',
      email: '',
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    message: '',
    isAliasExists: false,
    isSystemError: false,
  }),
  async created() {
    // 直接アクセスが来た際の対応(App.vueでのユーザー取得では間に合わない際があるので)
    let cognitoUser = await Auth.currentAuthenticatedUser()
    this.signedIn = true
    cognito_username = cognitoUser.username
    this.form.oldEmail = cognitoUser.attributes.email
  },
  validations: {
    form: {
      newEmail: {
        required,
        email,
        sameAs: not(sameAs('oldEmail')),
      },
    },
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        if (fieldName == 'newEmail') {
          if (field.$anyError || this.isAliasExists) {
            return { 'md-invalid': true };
          }
        }
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    resetAliasExists() {
      this.isAliasExists = false
    },
    clearForm() {
      this.$v.$reset()
      this.form.newEmail = null
    },
    clearErrorFlag() {
      this.isAliasExists = false
      this.isSystemError = false
    },
    async saveUser() {
      this.clearErrorFlag()
      this.sending = true
      window.setTimeout(async () => {
        try {
          let user = await Auth.currentAuthenticatedUser()
          let result = await Auth.updateUserAttributes(user, {
            email: this.form.newEmail,
            'custom:validated_email': this.email,
            'custom:standbye_email': this.form.newEmail,
          })
        } catch (error) {
          this.sending = false
          if (error.code == 'AliasExistsException') {
            this.isAliasExists = true
          } else {
            this.isSystemError = true
          }
          return
        }
        this.userSaved = true
        this.sending = false
        this.clearForm()
        this.$router.push('/verify-change-email')
      }, 1500)
    },
    async validateUser() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.isAliasExists = true
        return
      }
      this.isAliasExists = false
      this.saveUser()
    },
  },
}
</script>
<!-- #endregion -->
<!-- #region CSS -->
<style lang="scss" scoped>

/* #region base CSS */
.submit-container {
  padding-top: 50px;
  padding-bottom: 50px;
}

.md-card .md-card-actions {
  margin: 0 !important;
  padding-top: 0px !important;
  padding-bottom: 30px !important;
}

.md-card .md-card-content {
  padding-top: 0px;
  padding-bottom: 0px;
}

/* #endregion */

/* #region SP */
@media screen and (max-width:767px) {
  .submit-container {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .md-card .md-card-actions {
    padding-top: 0px !important;
    padding-bottom: 20px !important;
  }

  .md-card .md-card-content {
    padding-left: var(--card-horizontal-padding);
    padding-right: var(--card-horizontal-padding);
  }
}

/* #endregion */
</style>
<!-- #endregion -->